import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import 'react-app-polyfill/ie11';

import App from './App';
import './resources/styles/bootstrap.min.css';
import "./resources/styles/global.main.scss";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
